import axios from "axios";
import {useEffect, useRef, useState} from "react";

const SelectDynamicInputCard = (props) => {

    const [value, setValue] = useState("")
    const [optionsStyle, setOptionsStyle] = useState(false)
    const [optionInputs, setOptionInputs] = useState([]);

    const selectDynamicRef = useRef()

    function selectOption(event) {
        props.setNewFilters([])
        props.inputData.filters = []
        let inputDataObject = props.inputData;

        const keyValue = event.target.getAttribute("value")

        inputDataObject[props.keyItem] = keyValue
        props.setInputData(inputDataObject)


        setValue(event.target.innerText)

        setOptionsStyle(false)

        let count = selectDynamicRef.current.id.split("-")[1]

        let newOptionItem = props.selectRouteInputs.filter(
            (item, index) => Number(count) >= index
        );

        newOptionItem[+count].label = event.target.innerText;
        axios
            .get(`${props.route}${keyValue}`)
            .then((res) => {
                let newOptions = [];
                if (res.data.data.filters.length !== 0) {
                    props.setNewFilters(res.data.data.filters)
                } else {
                    props.setNewFilters([])
                }

                if (res.data.data.filters.length === 0 && res.data.data.categories.length === 0) {
                    props.setSelectRouteInputs([...newOptionItem]);
                    return
                }

                if (res.data.data.categories.length !== 0) {
                    for (let option of res.data.data.categories) {
                        newOptions.push({label: option.label, value: option.value});
                    }
                    props.setSelectRouteInputs([
                        ...newOptionItem,
                        {[`category_id-${+count + 1}`]: newOptions, label: null},
                    ]);
                } else {
                    props.setSelectRouteInputs([...newOptionItem]);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }


    useEffect(() => {
        if (props.pageType === "edit") {
            axios
                .get(`${props.route}${props.editData.data[props.keyItem]}`)
                .then((res) => {
                    const filtersEdit = res.data.data.filters
                    if (props.inputData.filters.length > 0) {
                        for (let key of filtersEdit) {
                            for (let item of props.inputData.filters) {
                                if (item.id === key.id) {
                                    key[item.id] = item.value
                                }
                            }
                        }
                    }
                    props.setNewFilters(filtersEdit)
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, []);

    function onChange(event) {
        setValue(event.target.value)
        const array = props.options.filter((item) => {
            return item.label.search(`${event.target.value}`) !== -1
        })
        setOptionInputs(array);
    }

    useEffect(() => {
        setValue(props.label)
        setOptionInputs(props.options)
    }, [setOptionInputs, props.options])

    useEffect(() => {
        document.body.addEventListener("click", (event) => {
            if (!event.target.matches("." + props.matchOptionId)) {
                setOptionsStyle(false)
            }
        })
    }, [])


    return (
        <div className="mb-[20px]">
            <input type="text"
                   className={`h-[38px] border border-edit_input_border rounded-[4px] px-3 w-full ${props.matchOptionId} ${
                       props.disabled !== undefined || props.disabled
                           ? "bg-[#e9e9e9] cursor-not-allowed dark:bg-[#2B2B2B] text-edit_input_text_disabled"
                           : "bg-white dark:bg-[#B5B5B5] text-edit_input_text"
                   }`}
                   value={value}
                   onChange={onChange}
                   onFocus={() => setOptionsStyle(true)}
                   id={props.id + "-0"}
                   ref={selectDynamicRef}
                   autoComplete="off"
                   disabled={props.disabled}
            />

            {
                optionsStyle &&
                <ul className="w-full bg-white absolute max-h-[200px] overflow-y-scroll top-38 border border-edit_input_border shadow-xl z-50">

                    {optionInputs && optionInputs.map(item => (
                        <li
                            key={item.value}
                            value={item.value}
                            className={`w-full py-[5px] px-[10px] ${props.matchOptionId} hover:bg-[#9cc8cae1]`}
                            onClick={selectOption}>
                            {item.label}
                        </li>
                    ))}
                </ul>
            }
        </div>);
}

export default SelectDynamicInputCard;